/**
 * ColetaContagemReport - Inline display for Solicitação de Coleta
 *
 * Columns: Descrição, Produto, Lote, Qtde
 */
import React from 'react';
import { RelatorioGeraisTable } from '../../relatorios-gerais/RelatorioGeraisTable';
import type { Column } from '../../relatorios-gerais/RelatorioGeraisTable';

interface Props {
  data: any[];
  loading: boolean;
  meta: any;
}

const columns: Column[] = [
  { key: 'descricao', label: 'Descrição', width: '300px' },
  { key: 'codigo', label: 'Produto', width: '120px' },
  { key: 'lote', label: 'Lote', width: '120px' },
  { key: 'quantidade_coletar', label: 'Qtde', align: 'right', format: 'number', width: '110px' },
];

export const ColetaContagemReport: React.FC<Props> = ({ data, loading, meta }) => {
  return (
    <div className="space-y-3">
      {meta && (
        <div className="text-sm text-gray-600 dark:text-gray-400 flex flex-wrap gap-4">
          {meta.empresa && <span><span className="font-medium">Empresa:</span> {meta.empresa}</span>}
          {meta.codigo_cliente && <span><span className="font-medium">Código do Cliente:</span> {meta.codigo_cliente}</span>}
          <span><span className="font-medium">Hospital:</span> {meta.hospital}</span>
          {meta.data_contagem && <span><span className="font-medium">Data:</span> {meta.data_contagem}</span>}
          {meta.total_items != null && <span>{meta.total_items} itens</span>}
        </div>
      )}
      <RelatorioGeraisTable
        columns={columns}
        data={data}
        loading={loading}
        showTotals
        emptyMessage="Nenhum item para coleta nesta contagem."
      />
      {meta?.lacres?.length > 0 && (
        <div className="text-sm text-gray-600 dark:text-gray-400 mt-2">
          <span className="font-medium">Lacre(s):</span> {meta.lacres.join(', ')}
        </div>
      )}
    </div>
  );
};
